import React, { useEffect, useRef, useState } from "react";
import { getBuilderUserByIdApi } from "../../services/apis/builderUserApis";
import { handleApiError } from "../../services/axiosService";
import Loader from "../../Layouts/Loader/Loader";
import Input from "../../components/FormComponents/Input";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import Button from "../../components/FormComponents/Button";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";
import Label from "../../components/FormComponents/Label";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import { getOrganisationsApi } from "../../services/apis/organisationApis";

const UserAssignOrgApp = ({ userId, onAssign }) => {
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [selectedApplications, setSelectedApplications] = useState([]);

  const [allOrgs, setAllOrgs] = useState([]);
  const [isClicked, setIsClicked] = useState(null);
  const userOrganization = useRef([]);
  const userApplicaation = useRef([]);
  const [isLoader, setIsLoader] = useState(false);

  const fetchSingleUser = async () => {
    try {
      setIsLoader(true);
      // 1. Get Response
      const response = await getBuilderUserByIdApi(userId);
      // 2. Access .data
      userOrganization.current = response.data.orgs;
      userApplicaation.current = response.data.apps;
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoader(false);
    }
  };

  const fetchOrganisations = async () => {
    try {
      // 1. Get Response
      const response = await getOrganisationsApi();
      // 2. Access .data
      setAllOrgs(response.data);
      createArrayOfOrgAndApp(response.data);
    } catch (error) {
      handleApiError(error);
    }
  };

  // ... rest of the logic remains same ...

  const createArrayOfOrgAndApp = (data) => {
    const organizationArray = [];
    const applicationArray = [];
    data.forEach((item) => {
      const organization = { id: item.id, name: item.name, apps: item.apps };
      organizationArray.push(organization);

      item.apps?.forEach((app) => {
        const application = { id: app.id, name: app.name };
        applicationArray.push(application);
      });
    });

    const userOrganizationArray = userOrganization.current || [];
    const includesOrganizations = [];
    organizationArray.forEach((obj) => {
      if (userOrganizationArray.includes(obj.id)) {
        includesOrganizations.push(obj);
      }
    });
    const userApplicationArray = userApplicaation.current || [];
    const includesApplications = [];

    applicationArray.forEach((obj) => {
      if (userApplicationArray.includes(obj.id)) {
        includesApplications.push(obj);
      }
    });
    setSelectedApplications(includesApplications);
    setSelectedOrganizations(includesOrganizations);
  };

  const removeSelectedAppsOfOrg = (apps) => {
    const newSelectedApps = selectedApplications.filter((obj) => !apps.some((idObj) => idObj.id === obj.id));
    setSelectedApplications(newSelectedApps);
  };

  const removeFromSelectedOrganization = (org) => {
    const removedItem = selectedOrganizations.filter((obj) => obj.id !== org.id);
    setSelectedOrganizations([...removedItem]);
    removeSelectedAppsOfOrg(org.apps);
  };

  const addToSelectedOrganization = (id) => {
    const findOrg = allOrgs.find((org) => org.id === id);
    setSelectedOrganizations([findOrg, ...selectedOrganizations]);
  };

  const removeFromSelectedApplication = (e, app) => {
    e.stopPropagation();
    const removedItem = selectedApplications.filter((obj) => obj.id !== app.id);
    setSelectedApplications([...removedItem]);
  };

  const addToSelectedApplication = (e, app) => {
    e.stopPropagation();
    setSelectedApplications([...selectedApplications, app]);
  };

  const handleAssignClick = () => {
    onAssign(userId, selectedOrganizations, selectedApplications);
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchSingleUser();
      await fetchOrganisations();
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="app_org_assign">
      {isLoader ? (
        <Loader width={30} />
      ) : (
        <div>
          <div className="user_org_container">
            <div className="user_org_heading" style={{ alignItems: "center" }}>
              <SingleSelectBox
                selectedData={""}
                options={allOrgs.filter((org) => !selectedOrganizations.some((idObj) => idObj.id === org.id))}
                onChange={(obj) => addToSelectedOrganization(obj.id)}
                placeholder="Search Organisation"
                isSearch={true}
                label="Add organisations"
              />
            </div>

            <div className="selection_tag">
              <Label>Assigned Organisations</Label>

              {selectedOrganizations?.map((org, i) => (
                <AssignUserOrg
                  key={org.id || i}
                  org={org}
                  removeOrg={removeFromSelectedOrganization}
                  selectedApps={selectedApplications}
                  removeApp={removeFromSelectedApplication}
                  addApp={addToSelectedApplication}
                  isClicked={isClicked}
                  setIsClicked={setIsClicked}
                  setSelectedApplications={setSelectedApplications}
                />
              ))}
            </div>

            {!isLoader && <Button onClick={handleAssignClick}>Assign</Button>}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAssignOrgApp;

const AssignUserOrg = ({
  org,
  removeOrg,
  selectedApps,
  addApp,
  removeApp,
  isClicked,
  setSelectedApplications,
  setIsClicked
}) => {
  const [search, setSearch] = useState("");

  const isExpanded = isClicked === org.id;

  const checkSelectedApp = (appId) => selectedApps.some((obj) => obj.id === appId);

  const assignedCount = org.apps?.filter((app) => checkSelectedApp(app.id)).length || 0;

  const allAppsPresent = (apps) => apps?.length && apps.every((app) => selectedApps.some((ref) => ref.id === app.id));

  const handleAllOrgApps = (e, apps) => {
    e.stopPropagation();

    if (e.target.checked) {
      const newApps = apps.filter((app) => !selectedApps.some((s) => s.id === app.id));
      setSelectedApplications((prev) => [...prev, ...newApps]);
    } else {
      const remaining = selectedApps.filter((s) => !apps.some((app) => app.id === s.id));
      setSelectedApplications(remaining);
    }
  };

  const toggleApp = (e, app) => {
    e.stopPropagation();
    checkSelectedApp(app.id) ? removeApp(e, app) : addApp(e, app);
  };

  const filteredApps = org.apps?.filter((app) => app.name.toLowerCase().includes(search.toLowerCase()));

  const toggleExpand = () => {
    setIsClicked(isExpanded ? null : org.id);
  };

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "10px",
        marginBottom: "10px",
        overflow: "hidden",
        backgroundColor: "#ffffff"
      }}
    >
      <div
        onClick={toggleExpand}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px",
          cursor: "pointer",
          backgroundColor: isExpanded ? "#f3f4f6" : "#ffffff",
          transition: "background-color 0.2s ease"
        }}
      >
        <div>
          <div style={{ fontSize: "14px", fontWeight: 600 }}>{org.name}</div>
          <div style={{ fontSize: "12px", color: "#6b7280" }}>
            {assignedCount} / {org.apps?.length || 0} apps assigned
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <MaterialIcon
            name="expand_more"
            style={{
              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease"
            }}
          />

          <div onClick={(e) => e.stopPropagation()}>
            <ButtonActionIcon size="xsm" type="delete" onClick={() => removeOrg(org)} />
          </div>
        </div>
      </div>

      {isExpanded && (
        <div
          style={{
            padding: "12px",
            borderTop: "1px solid #e5e7eb",
            backgroundColor: "#f9fafb"
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              marginBottom: "10px",
              justifyContent: "space-between"
            }}
          >
            <Input
              type="text"
              placeholder="Search apps"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              size="small"
              containerStyle={{ width: "180px" }}
              inputBoxStyle={{
                height: "28px",
                fontSize: "12px",
                padding: "4px 8px"
              }}
            />

            <Input
              type="checkbox"
              label="Assign all"
              size="small"
              checked={allAppsPresent(org.apps)}
              onChange={(e) => handleAllOrgApps(e, org.apps)}
            />
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px"
            }}
          >
            {filteredApps?.length ? (
              filteredApps.map((app) => {
                const selected = checkSelectedApp(app.id);

                return (
                  <div
                    key={app.id}
                    onClick={(e) => toggleApp(e, app)}
                    style={{
                      cursor: "pointer",
                      padding: "6px 12px",
                      borderRadius: "20px",
                      fontSize: "13px",
                      userSelect: "none",
                      border: selected ? "1px solid #2563eb" : "1px solid #d1d5db",
                      backgroundColor: selected ? "#eff6ff" : "#ffffff",
                      color: selected ? "#1d4ed8" : "#374151",
                      transition: "all 0.15s ease"
                    }}
                  >
                    {app.name}
                  </div>
                );
              })
            ) : (
              <div style={{ fontSize: "13px", color: "#6b7280" }}>No apps found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
